import type { AlertStylesType } from '@material-tailwind/react';

const styles: AlertStylesType = {
  defaultProps: {
    color: 'blue-gray',
    variant: 'ghost',
    className: 'gap-2.5',
  },
  valid: {
    variants: ['ghost'],
    colors: ['blue-gray'],
  },
  styles: {
    variants: {
      ghost: {
        'blue-gray': {
          // TODO: This is normally bg-blue-gray-500/20 but by overwriting everything in tailwind.config this does not work
          background: 'bg-blue-gray-50',
          color: 'text-blue-gray-900',
        },
      },
    },
  },
};

export default styles;
